import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';
import {
  EnvironmentSettings,
  ENVIRONMENT_SETTINGS,
  ICookieConsentSettings,
} from '@epicuro-next/platform/environment';

@Injectable()
export class CookieConsentService {
  private renderer: Renderer2;

  constructor(
    @Inject(ENVIRONMENT_SETTINGS)
    private environmentSettings: EnvironmentSettings,
    private rendererFactory: RendererFactory2,
  ) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  public setCookieConsent() {
    let cookieConsent: ICookieConsentSettings | null = null;

    try {
      cookieConsent = JSON.parse(this.environmentSettings.cookieConsent ?? '');
    } catch {}

    if (!cookieConsent) {
      return;
    }

    const tag = this.renderer.createElement(cookieConsent.injectType);

    if (cookieConsent.injectType === 'script') {
      this.renderer.setAttribute(tag, 'type', 'text/javascript');
    }

    this.setAttributes(tag, cookieConsent.attributes);

    this.renderer.appendChild(document.body, tag);
  }

  private setAttributes(
    element: HTMLElement,
    attributes: { [key: string]: unknown },
    prefix?: string,
  ) {
    Object.keys(attributes).forEach((key) => {
      if (attributes[key] instanceof Object) {
        this.setAttributes(
          element,
          attributes[key] as { [key: string]: unknown },
          key,
        );

        return;
      }

      this.renderer.setAttribute(
        element,
        `${prefix ? prefix + '-' : ''}${key}`,
        attributes[key] as string,
      );
    });
  }
}
